import React, {Component} from "react";
import SvGraphics from "../../assets/SvGraphics";
import Prototypes from 'prop-types'
import HCPEntryForm from "./HCPEntryForm";
import {adminApi} from "../../services/ApiService";
import {makeError} from "../modals/ErrorModal";
import {sendMessage} from "../modals/MessageModal";
import {authenticationService} from "../../services/AuthenticationService";

class ClinicAdminHcpEntryForm extends Component {
    render() {
        return null;
    }
}

ClinicAdminHcpEntryForm.propTypes = {
    addNewHCP: Prototypes.func,
    t: Prototypes.func,
    closeSideBar: Prototypes.func
};

class HCPsTabTools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterHcpTable:'',
            searchValue: '',
            isSideBarOpen: false,
        };
    }

    componentDidMount() {
    }

    filterHcpTable(val){
        this.setState({searchValue:val})
        this.props.filterHcpTable(val)
    }

    openSideBar(){
        document.body.style.overflow = "hidden"
        this.setState({isSideBarOpen:true})
    }

    sendMessage = async () => {
        let {t} = this.props
        if (this.props.recipients.length > 0){
            let Method = await sendMessage({
            },this.props.recipients);
            if (Method){
                let DoctorsIDs = this.props.recipients.map(user =>{
                    return user.id
                })
                await adminApi.sendMessageToHcp({Method,DoctorsIDs})
            }
        } else {
            await makeError({
                proceedLabel: t('admin.hcp.tools.ok'),
                options:{
                    title: t('admin.hcp.tools.could_not_opn_msg'),
                }
            },[t('admin.hcp.tools.select_recipients')]);
        }
    }

    render() {
        let {t} = this.props
        let {isSideBarOpen} = this.state
        let current  = authenticationService.currentUserValue
        let TabTools_Size = 'Admin-TabTools'
        return (
            <div className={`${TabTools_Size} custom-control`}>
                <div className={"TabTools-container"}>
                    <div className={"rounded-button-wrapper"}>
                        <button disabled type={"button"} className={"btn btn-primary rounded-btn"} onClick={this.sendMessage.bind(this)}>
                            <SvGraphics className={"mail-pic centered"} svgname={'mail'} style={{width: '25px', height: '25px'}}/>
                        </button>
                    </div>
                    <div className={"rounded-button-wrapper"}>
                        <button type={"button"} className={"btn btn-primary rounded-btn"} onClick={() => {
                            let filters = document.getElementsByClassName('table-filter')
                            for (let i = 0; i < filters.length; i++) {
                                if (filters[i].style.display === "none"){
                                    filters[i].style.display = "inline-block";
                                }
                                else filters[i].style.display = "none"
                            }
                        }}>
                            <SvGraphics className={"filter-pic centered"} svgname={'filter'} style={{width: '25px', height: '25px'}}/>
                        </button>
                    </div>
                    <div className={"button-wrapper"}>
                        <button type={"button"} onClick={this.openSideBar.bind(this)} className={"btn btn-primary "}>+ {t('admin.hcp.tools.add_new')}</button>
                    </div>
                    <div className={"search-wrapper"}>
                        <input className={"sade-input"} placeholder={t('admin.hcp.tools.search')} type="text" name="search"
                               id={"search"}
                               onChange={event => this.filterHcpTable(event.target.value)} value={this.state.searchValue}/>
                       <SvGraphics className={"input-pic"} svgname={'search'} style={{width: '40px', height: '20px'}}/>
                    </div>
                </div>
                {isSideBarOpen && !current?.profile?.Doctor?.isClinicAdmin && <HCPEntryForm
                    t={e => t(e)}
                    title={t('admin.hcp.form.add_new')}
                    isSideBarOpen={isSideBarOpen}
                    addNewHCP={hcp => this.props.addNewHCP(hcp)}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>
        );
    }
}

HCPsTabTools.Prototypes = {
    filterHcpTable: Prototypes.func.isRequired,
    addNewHCP: Prototypes.func.isRequired,
}

export default HCPsTabTools

